import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

class SelectInputWithSuggestions extends Component {

  static propTypes = {
    input: PropTypes.any.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    suggestions: PropTypes.array,
  }

  constructor() {
    super()

    this.handleOnChange = selectedOption => {
      this.props.input.onChange( selectedOption && selectedOption.value)
    }
  }

  render() {
    const { input, placeholder, label, suggestions } = this.props

    return (
      <div className="form-group" id={label}>
        {label && <label>{label}</label>}
        <Select
          value={input.value}
          onChange={this.handleOnChange}
          options={suggestions}
          matchPos="start"
          placeholder={placeholder}
        />
      </div>
    )
  }
}

export default SelectInputWithSuggestions



// WEBPACK FOOTER //
// ./src/components/ui/forms/SelectInputWithSuggestions.js